import script from "./LoadingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingPage.vue?vue&type=script&setup=true&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=e70d3aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e70d3aaa"]])

export default __exports__